<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>Google Search Consoleを連携します。</h1>
        </div>
        <div class="message c-text--center">
          <p>次に、Google Search Consoleの認証を行います。</p>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isProcessing"
              @click="submit"
            >
              アカウント認証に進む
            </Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Button from '@/components/Button';
import apiAuthorization from '@/api/authorization';
import Progress from '@/components/Progress';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';
export default {
  props: ['hasProject'],

  components: {
    Button,
    Progress,
    SetLocalNav,
    TitleRegister
  },

  data() {
    return {
      params: Object.assign({}, this.$store.state.set.params),
      isProcessing: false,
      progress: [
        {
          label: 'Google Analyticsの登録'
        },
        {
          current: true,
          label: 'Google Search Consoleの登録'
        },
        {
          label: '確認'
        }
      ]
    };
  },

  methods: {
    submit() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      this.$store.dispatch('set/setParams', this.params);
      this.$store.dispatch('set/resetGSC');

      apiAuthorization.gsc.redirect(this.auth.idToken, this.params.tmpKey);
    }
  }
};
</script>
